<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('c2c.sp')}}</div>
        </div>
        <div class="frame-box">
          <video width="100%" height="600" controls :src="videoUrl">
            <source />
          </video>
        </div>

    </div>
</template>
<script>
export default {
    name: 'videos',
    data () {
        return {
          videoUrl: '',
        }
    },
    mounted(){
        this.getParams();
    },
    methods: {
        getParams(){
            var that = this;
            this.$ajax.get('/web/getParam',{}).then((res) => {
                let resData = res.data.data;
                for(var i=0;i< resData.length; i++){
                    if(resData[i].key == 'tb_eth_video_link'){
                        that.videoUrl = resData[i].value.replace(/(^\s*)|(\s*$)/g, "");
                    }
                }

            }).catch(function(err){
                console.log(err)
            })
        },
        goBack(){
            this.$router.go(-1);
        }
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }

    .frame-box{
        position: absolute;
        left: 0;
        right: 0;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: calc(100% - 1.2rem);
    }
    .frame{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/videos.vue